import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-check-o",
  "use": "icon-ib-check-o-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-check-o\">\n    <path d=\"M947.584 204.586667a42.666667 42.666667 0 0 1-0.170667 60.330666l-557.312 554.666667a42.666667 42.666667 0 0 1-60.16 0l-253.354666-252.16a42.666667 42.666667 0 1 1 60.16-60.458667l223.232 222.165334L887.296 204.416a42.666667 42.666667 0 0 1 60.330667 0.170667z\" p-id=\"9780\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol